export default __webpack_public_path__ + "letter-p-symbol.png";